import cx from 'classnames';
import styles from 'partials/data-table/data-table.module.scss';

export const DataTableRowCell = ({
	children,
	cellText,
	cellHead,
	cellClassName,
	boxClassName
}) => {
	const cellClass = cx(styles.cell, cellClassName);
	const boxClass = cx(styles.rowBox, boxClassName);
	
	return (
		<li className={cellClass} data-th={cellHead}>
			<div className={boxClass} title={cellText}>
				{children ? children : cellText}
			</div>
		</li>
	);
};
